/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/webflow.css?v=20210331";
import "./src/styles/normalize.css?v=20210331";
import "./src/styles/agenda-base-html.css?v=20210331";
import { navigate } from "gatsby";
import {
  isBlockedEventPath,
  redirectBlockedEvent,
} from "./src/utils/blockedEventRedirect";

export const onClientEntry = () => {
  redirectBlockedEvent();
};

export const onRouteUpdate = ({ location }) => {
  if (isBlockedEventPath(location.pathname)) {
    navigate("/home/", { replace: true });
  }
};

export const wrapPageElement = ({ element, props }) => {
  if (isBlockedEventPath(props.location.pathname)) {
    return null;
  }
  return element;
};
